import AddStreamNode from './addStreamNode'
import validatorMixin from '@/mixins/validator-mixin.js' // 引入mixin文件
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import {getRunScheduleList, getRegionList, getEncoderList} from '@/api/get-data.js'
import {download} from '@/utils/download'

export default {
  name: 'CaptureTask',
  data () {
    return {
      // 选择器和表格数据
      servicesIncludeAll: [],
      runModesIncludeAll: [],
      runSchedulesIncludeNone: [],
      tableData: [],
      tableTotalRow: 0,
      // 遮罩层
      loading: false,
      // 查询条件
      serviceSelectQueryParams: {
        serverId: 0,
        serviceId: 0,
        serviceKind: 21,
        pageNum: 1,
        pageSize: 1000
      },
      tableQueryParams: {
        serviceId: -1,
        runMode: 255,
        pageNum: 1,
        pageSize: 10
      },
      // 表格选中记录数组
      tableSelectedIds: [],
      // 表格当前行id
      tableCurrentId: 0,
      // 记录编辑
      modalOpen: false,
      modalForm: {
        id: undefined,
        name: undefined,
        runMode: 1,
        captureMethod: 0,
        streamOpenMode: 255,
        captureInterval: 300,
        maxCaptureTimes: 0,
        captureDir: 'd:/nsp/capture',
        pictureFormat: 1,
        runScheduleId: 0,
        serviceId: undefined,
        scope: 0,
        runState: undefined
      },
      // 表单校验
      formRules: {
        name: [
          { required: true, message: '抓拍任务名称不能为空', trigger: 'blur' }
        ],
        runMode: [
          { required: true, message: '运行模式不能为空', trigger: 'blur' }
        ],
        captureMethod: [
          { required: true, message: '抓拍方式不能为空', trigger: 'blur' }
        ],
        streamOpenMode: [
          { required: true, message: '流打开模式不能为空', trigger: 'blur' }
        ],
        captureInterval: [
          { required: true, message: '抓拍间隔不能为空', trigger: 'blur' }
        ],
        captureDir: [
          { required: true, message: '抓拍目录不能为空', trigger: 'blur' }
        ],
        pictureFormat: [
          { required: true, message: '抓拍文件格式不能为空', trigger: 'blur' }
        ],
        runScheduleId: [
          { required: true, message: '运行时刻表不能为空', trigger: 'blur' }
        ],
        serviceId: [
          { required: true, message: '抓拍服务不能为空', trigger: 'blur' }
        ],
        scope: [
          { required: true, message: '适用范围不能为空', trigger: 'blur' }
        ]
      },
      // 数据导入
      upload: {
        // 是否显示数据导入弹出层
        open: false,
        // 弹出层标题（数据导入）
        title: '数据导入',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的记录数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: '',
        // 上传的地址
        url: '/api/captureTask/import'
      },
      // 子表活动页面索引
      activeTabName: '0',
      // 视频节点表格数据
      streamNodeTableData: [],
      streamNodeTableTotalRow: 0,
      // 视频节点遮罩层
      streamNodeTableLoading: false,
      // 视频节点查询条件
      streamNodeTableQueryParams: {
        captureTaskId: 0,
        pageNum: 1,
        pageSize: 10
      },
      streamNodeTableDeleteParams: {
        captureTaskId: 0,
        streamNodeIdCount: 0,
        streamNodeIds: []
      },
      // 视频节点表格选中记录数组
      streamNodeTableSelectedIds: [],
      // 视频节点记录编辑
      streamNodeModalOpen: false,
      streamNodeModalForm: {
        id: undefined,
        name: undefined,
        localPath: undefined,
        virtualPath: undefined,
        serverId: undefined,
        totalSize: undefined,
        availableSize: undefined,
        usedSize: undefined,
        reservedSize: 0.0
      }
    }
  },
  components: {
    AddStreamNode
  },
  mixins: [
    validatorMixin,
    ssoLoginMixin,
    idNameMixin,
    convertorMixin
  ],
  computed: {
  },
  watch: {
  },
  mounted () {
    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取运行时刻表数组
      getRunScheduleList(() => {
        // 获取区域列表
        getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
          // 获取监控设备列表
          getEncoderList(() => {
            // 创建运行模式数组
            this.runModesIncludeAll = [{id: 255, name: '全部'}] // 插入‘全部’选项
            this.runModesIncludeAll.push(...this.$type.runModes)
            // 获取抓拍存储服务列表
            this.getRecordServerServiceList()
            //
            this.runSchedulesIncludeNone = [{id: 0, name: '无'}] // 插入‘无’选项
            this.runSchedulesIncludeNone.push(...this.$globalData.runSchedules)
          })
        })
      })
    })
  },
  methods: {
    // 获取抓拍服务列表
    getRecordServerServiceList () {
      this.loading = true
      this.$http(this.$api.serviceList, this.serviceSelectQueryParams).then(
        res => {
          this.loading = false
          if (res.code === 200) {
            this.servicesIncludeAll = [{id: 0, name: '全部'}] // 插入‘全部’选项
            this.servicesIncludeAll.push(...res.data)
            this.tableQueryParams.serviceId = 0
            return res
          }
        }
      ).then((res) => {
        this.getCaptureTaskList()
      })
    },
    // 获取抓拍任务列表
    getCaptureTaskList () {
      this.loading = true
      this.$http(this.$api.captureTaskList, this.tableQueryParams).then(
        res => {
          this.loading = false
          if (res.code === 200) {
            res.data.forEach(item1 => {
              if (item1.serviceId === 0) {
                item1.serviceName = '全部'
              } else {
                item1.serviceName = this.getNameById(item1.serviceId, this.servicesIncludeAll)
              }
            })
            this.tableData = res.data
            this.tableTotalRow = res.page.totalRow
            if (res.data.length) {
              this.$refs.table.setCurrentRow(res.data[0]) // 选中首行
            }
          }
        }
      )
    },
    // 查询按钮操作
    handleFormQuery() {
      this.tableQueryParams.pageNum = 1
      this.getCaptureTaskList()
    },
    // 重置按钮操作
    resetQueryForm() {
      this.tableQueryParams.serviceId = 0
      this.tableQueryParams.runMode = 255
      this.$refs['queryForm'].resetFields()
      this.handleFormQuery()
    },
    // 分页
    handleCurrentPageChange(val) {
      this.tableQueryParams.pageNum = val
      this.getCaptureTaskList()
    },
    // 页面条数改变
    handlePageSizeChange(val) {
      this.tableQueryParams.pageSize = val
      this.getCaptureTaskList()
    },
    // 表格选中记录改变
    handleTableSelectionChange(selection) {
      this.tableSelectedIds = selection.map(item => item.id)
    },
    // 表格当前记录改变
    handleTableCurrentChange(currentRow, oldCurrentRow) {
      if (currentRow == null) {
        return
      }

      this.tableCurrentId = currentRow.id
      this.streamNodeTableQueryParams.captureTaskId = currentRow.id
      this.streamNodeTableDeleteParams.captureTaskId = currentRow.id
      this.getStreamNodeList()
    },
    // 新增记录
    handleAdd() {
      this.resetModalForm()
      this.modalOpen = true
    },
    // 修改记录
    handleModify(data) {
      this.modalForm.id = data.id
      this.modalForm.name = data.name
      this.modalForm.runMode = data.runMode
      this.modalForm.captureMethod = data.captureMethod
      this.modalForm.streamOpenMode = data.streamOpenMode
      this.modalForm.captureInterval = data.captureInterval / 1000
      this.modalForm.maxCaptureTimes = data.maxCaptureTimes
      this.modalForm.captureDir = data.captureDir
      this.modalForm.pictureFormat = data.pictureFormat
      this.modalForm.runScheduleId = data.runScheduleId
      this.modalForm.serviceId = data.serviceId
      this.modalForm.scope = data.scope
      this.modalForm.runState = data.runState
      this.modalOpen = true
    },
    // 重置表单
    resetModalForm() {
      this.modalForm = {
        id: undefined,
        name: undefined,
        runMode: 1,
        captureMethod: 0,
        streamOpenMode: 255,
        captureInterval: 300,
        maxCaptureTimes: 0,
        captureDir: 'd:/nsp/capture',
        pictureFormat: 1,
        runScheduleId: 0,
        serviceId: undefined,
        scope: 0,
        runState: undefined
      }
    },
    // 提交新增或修改记录
    handleModalSubmit() {
      this.$refs.modalForm.validate((valid) => {
        if (!valid) {
          return
        }

        this.modalOpen = false
        this.modalForm.captureInterval = this.modalForm.captureInterval * 1000
        this.$http(this.modalForm.id === undefined ? this.$api.addCaptureTask : this.$api.updateCaptureTask, this.modalForm).then(res => {
          this.resetModalForm()
          this.getCaptureTaskList()
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          }
        })
      })
    },
    // 取消提交记录
    handleModalCancel() {
      this.resetModalForm()
      this.modalOpen = false
    },
    // 删除记录
    handleDelete(row) {
      if (row && row.id) {
        this.$messagebox.confirm('您确定删除当前选中记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http(this.$api.deleteCaptureTask, {
            id: row.id
          }).then(
            res => {
              if (res.code === 200) {
                this.tableQueryParams.pageNum = 1
                this.getCaptureTaskList()
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
              }
            }
          )
        })
      } else if (this.tableSelectedIds.length > 0) {
        this.$messagebox.confirm('您确定删除选中的' + this.tableSelectedIds.length + '条记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let code = 400
          for (let i = 0; i < this.tableSelectedIds.length; ++i) {
            this.$http(this.$api.deleteCaptureTask, {
              id: this.tableSelectedIds[i]
            }).then(res => {
              code = res.code
            })
          }

          if (code === 200) {
            this.tableQueryParams.pageNum = 1
            this.getCaptureTaskList()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
      }
    },
    // 导入按钮操作
    handleImport() {
      this.upload.title = '数据导入'
      this.upload.open = true
    },
    // 下载模板操作
    handleDownloadTemplate() {
      this.$http(this.$api.downloadCaptureTaskTemplate, null).then(
        res => {
          if (res.code === 200) {
            download(res.data.url)
          }
        })
    },
    // 提交上传文件
    handleFileUploadSubmit() {
      this.$refs.upload.submit()
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true
    },
    // 文件上传成功处理
    handleFileUploadSuccess(res, file, fileList) {
      this.upload.open = false
      this.upload.isUploading = false
      this.$refs.upload.clearFiles()
      this.$alert(res.msg, '导入结果', { dangerouslyUseHTMLString: true })
      this.getCaptureTaskList()
    },
    //  导出按钮操作
    handleExport() {
      this.$confirm('是否确认导出所有记录?', '询问', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        this.$http(this.$api.exportCaptureTask, this.tableQueryParams).then(
          function (res) {
            if (res.code === 200) {
              download(res.data.url)
            }
          })
      })
    },
    /** 以下是视频节点页面相关操作 **/
    // 根据抓拍任务查询关联的视频节点
    getStreamNodeList () {
      this.streamNodeTableLoading = true
      this.$http(this.$api.streamNodeListForCaptureTask, this.streamNodeTableQueryParams).then(
        res => {
          this.streamNodeTableLoading = false
          if (res.code === 200) {
            this.streamNodeTableData = res.data
            this.streamNodeTableTotalRow = res.page.totalRow
          }
        }
      )
    },
    // 视频节点分页
    handleStreamNodeCurrentPageChange (val) {
      this.streamNodeTableQueryParams.pageNum = val
      this.getStreamNodeList()
    },
    // 视频节点页面条数改变
    handleStreamNodePageSizeChange(val) {
      this.streamNodeTableQueryParams.pageSize = val
      this.getStreamNodeList()
    },
    // 视频节点表格选中记录改变
    handleStreamNodeTableSelectionChange(selection) {
      this.streamNodeTableSelectedIds = selection.map(item => item.id)
    },
    // 视频节点新增记录
    handleAddStreamNode() {
      this.streamNodeModalOpen = true
    },
    // 视频节点提交新增或修改记录
    handleStreamNodeModalSubmit() {
      this.streamNodeModalOpen = false
      this.streamNodeTableQueryParams.pageNum = 1
      this.getStreamNodeList()
    },
    // 视频节点取消提交记录
    handleStreamNodeModalCancel() {
      this.streamNodeModalOpen = false
    },
    // 视频节点删除记录
    handleDeleteStreamNode(row) {
      let ids = []
      if (row) {
        ids.push(row.id)
      } else {
        ids = this.streamNodeTableSelectedIds
      }

      if (ids) {
        this.$messagebox.confirm('您确定删除选中记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.streamNodeTableDeleteParams.streamNodeIdCount = 1
          this.streamNodeTableDeleteParams.streamNodeIds = ids
          this.$http(this.$api.deleteStreamNodeForCaptureTask, this.streamNodeTableDeleteParams).then(
            res => {
              if (res.code === 200) {
                this.streamNodeTableQueryParams.pageNum = 1
                this.getStreamNodeList()
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
              }
            }
          )
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/system/captureTask/CaptureTask.js